import React from 'react'
import { Outlet } from 'react-router-dom'
import Navbar from '../../components/navbar'
import Footer from '../../sections/footer'

function PublicLayout({ user }) {
    return (
        <div>
            <Navbar user={user} />
            <Outlet />
            <Footer />
        </div>
    )
}

export default PublicLayout